export const DEFAULT_LOGO_PROPS = (variant: 'primary' | 'surface') => ({
  image: {
    altText: 'Logo',
    src: variant === 'primary' ? '/images/logo.svg' : '/images/dawn-logo-dark.svg',
  },
  label: 'Return home',
  href: '/',
});
